let basUrl;
if (process.env.NODE_ENV === "development") {
    // 开发环境
    basUrl = 'http://127.0.0.1:8888'
    // basUrl = 'https://api.cactusjack.top'
} else {
    // 打包
    basUrl = 'https://api.cactusjack.top'
}

export {basUrl}
